import React from 'react';
import styled, { keyframes } from "styled-components"


const dash1 = keyframes`
    50% {
        stroke-dashoffset: 1000;
    }
`

const dash2 = keyframes`
    50% {
        stroke-dashoffset: 0;
    }
`

const Svg = styled.svg`
    stroke-width: 8;
    width: 100px;
    fill: none;
    :first-child{
        stroke: ${({ theme }) => theme.color.primaryText};
        animation: ${dash2} 3s infinite;
        stroke-dasharray: 1000;
        stroke-dashoffset: 1000;
        stroke-linecap: round;
    }
    :nth-child(2) {
        stroke: ${({ theme }) => theme.color.primaryText};
        animation: ${dash1} 3s infinite;
        stroke-dasharray: 1000;
        stroke-dashoffset: 0;
        stroke-linecap: round;
    }
`

const Loading = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content : center;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 10;
  background-color: ${({ theme }) => theme.color.background}
`
//   }

const Animation = () => {
    return (
        <Loading>
            <Svg width="100%" height="100%" viewBox="0 0 249 251" version="1.1" xmlns="http://www.w3.org/2000/svg"
                xmlnsXlink="http://www.w3.org/1999/xlink" xmlSpace="preserve" xmlnsSerif="http://www.serif.com/"
                style={{ fillRule: "evenodd", clipRule: "evenodd", strokeLinejoin: "round", strokeMiterlimit: "1.41421" }}>
                <path
                    d="M29.727,36.554c0.12,-0.262 0.243,-0.523 0.368,-0.783c0.498,-1.038 2.298,-4.779 2.782,-5.786c0.081,-0.167 0.164,-0.333 0.25,-0.498c1.005,-1.914 2.212,-3.715 3.601,-5.371c2.889,-3.439 6.385,-6.412 10.397,-8.73c1.261,-0.729 2.554,-1.381 3.871,-1.957c5.045,-2.182 10.527,-3.168 16.016,-2.88c1.847,0.068 3.699,0.165 3.699,0.165l3.98,0.349c0.117,0.024 0.117,0.024 0,0c62.506,5.514 117.246,37.761 152.376,85.579c1.882,2.545 3.706,5.136 5.466,7.773c3.799,5.717 5.856,12.413 5.924,19.276c0.007,0.069 0.008,0.139 0.008,0.208c0.022,3.855 -0.529,7.632 -1.598,11.228c-0.989,3.279 -2.454,6.394 -4.348,9.247c-1.075,1.668 -2.195,3.305 -3.335,4.926l-0.206,0.29c-35.035,49.452 -90.542,83.673 -154.064,89.494c0.632,-0.138 0.632,-0.138 0,0l-4.203,0.379c0,0 -1.852,0.1 -3.698,0.199c-5.286,0.286 -10.569,-0.617 -15.46,-2.643c-1.44,-0.62 -2.858,-1.316 -4.24,-2.104c-3.863,-2.203 -7.255,-5.013 -10.077,-8.273c-1.645,-1.891 -3.065,-3.967 -4.23,-6.187c-0.008,0.004 -0.008,0.004 -0.008,0.004l-3.041,-6.32c-12.528,-27.104 -19.512,-57.264 -19.512,-89.043c0,-31.591 6.902,-61.583 19.282,-88.542Z" />
                <path
                    d="M133.178,97.334c2.018,-3.777 4.16,-7.554 6.512,-11.33c1.222,-1.951 3.288,-3.217 5.582,-3.42c6.436,-0.531 12.906,-0.469 19.405,0.057c2.107,0.178 4.035,1.254 5.293,2.953c9.257,12.591 16.635,25.85 22.404,39.681c0.769,1.862 0.741,3.957 -0.078,5.798c-5.626,12.553 -12.324,24.463 -19.762,35.928c-0.708,1.085 -1.979,1.663 -3.262,1.483c-1.282,-0.181 -2.345,-1.086 -2.727,-2.324c-1.373,-4.578 -3.654,-8.705 -7.018,-12.292c-2.35,-2.553 -2.59,-6.403 -0.575,-9.228c3.284,-4.641 6.093,-9.52 8.314,-14.692c0.475,-1.122 0.496,-2.384 0.059,-3.522c-2.709,-6.987 -4.107,-9.159 -8.948,-15.174c-0.765,-0.939 -1.861,-1.548 -3.062,-1.7c-5.185,-0.632 -10.395,-0.748 -15.625,-0.482c3.799,6.721 4.984,9.176 7.916,16.205c0.769,1.862 0.741,3.957 -0.078,5.798c-5.626,12.553 -12.323,24.463 -19.761,35.928c-0.708,1.085 -1.98,1.663 -3.262,1.483c-1.283,-0.181 -2.346,-1.086 -2.727,-2.324c-1.373,-4.578 -3.655,-8.705 -7.019,-12.292c-2.35,-2.553 -2.589,-6.403 -0.575,-9.228c3.285,-4.641 6.093,-9.52 8.315,-14.692c0.474,-1.122 0.495,-2.384 0.059,-3.522c-2.709,-6.987 -3.872,-8.676 -8.713,-14.691c-0.765,-0.939 -1.861,-1.548 -3.062,-1.7c-5.185,-0.632 -10.395,-0.748 -15.625,-0.483c3.799,6.721 4.749,8.694 7.68,15.723c0.769,1.862 0.741,3.957 -0.077,5.798c-5.626,12.553 -12.324,24.463 -19.762,35.928c-0.708,1.085 -1.979,1.663 -3.262,1.483c-1.283,-0.181 -2.346,-1.086 -2.727,-2.324c-1.373,-4.578 -3.655,-8.705 -7.018,-12.292c-2.35,-2.553 -2.59,-6.403 -0.575,-9.228c3.284,-4.641 6.093,-9.52 8.314,-14.692c0.474,-1.122 0.495,-2.384 0.059,-3.522c-2.709,-6.987 -6.269,-13.585 -11.111,-19.6c-0.764,-0.939 -1.86,-1.547 -3.061,-1.699c-6.01,-0.733 -12.054,-0.773 -18.122,-0.328c-1.209,0.091 -2.373,-0.481 -3.042,-1.493c-0.668,-1.013 -0.735,-2.308 -0.176,-3.384c2.415,-4.64 4.988,-9.28 7.877,-13.918c1.222,-1.951 3.288,-3.217 5.581,-3.42c6.436,-0.531 12.907,-0.469 19.405,0.057c2.107,0.178 4.036,1.254 5.293,2.953c2.832,3.852 5.488,7.766 7.976,11.74c2.018,-3.777 4.161,-7.554 6.512,-11.33c1.223,-1.951 3.289,-3.217 5.582,-3.42c6.436,-0.531 12.907,-0.469 19.405,0.057c2.107,0.178 4.035,1.254 5.293,2.953c2.832,3.852 5.488,7.766 7.976,11.74Z" />
            </Svg>
        </Loading>
    )
}
export default Animation;